import { render, staticRenderFns } from "./BlacklistPopUp.vue?vue&type=template&id=bb6b1100&"
import script from "./BlacklistPopUp.vue?vue&type=script&lang=js&"
export * from "./BlacklistPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb6b1100')) {
      api.createRecord('bb6b1100', component.options)
    } else {
      api.reload('bb6b1100', component.options)
    }
    module.hot.accept("./BlacklistPopUp.vue?vue&type=template&id=bb6b1100&", function () {
      api.rerender('bb6b1100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/blacklist/BlacklistPopUp.vue"
export default component.exports